import {apiConstants, config, downloadBlob, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

const LOAN_LIBRARY_LOAN_API_URL = `${config.URL}loan-library/loans`;

class serverLoanLibraryLoanApi {
    static getLoanHistory(searchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(searchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/history?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getRecentLoans(take: number = 10) {
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/recent?take=${take}`,
                requestTypes.GET,
            ),
        );
    }

    static getLoansReadyForProcessing(filters: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(filters as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/ready-for-processing?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getOverdueLoans() {
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/overdue`,
                requestTypes.GET,
            ),
        );
    }

    static updateLoans(loanItems: Record<string, unknown>[]) {
        return sendRequest(
            requestOptions(LOAN_LIBRARY_LOAN_API_URL,
                requestTypes.PUT,
                JSON.stringify(loanItems),
                apiConstants.successMessage.loanLibrary.LOAN_UPDATED,
            ),
        );
    }

    static renewLoan(renewDto: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/renew`,
                requestTypes.POST,
                JSON.stringify(renewDto),
                apiConstants.successMessage.loanLibrary.LOAN_RENEWED,
            ),
        );
    }

    static getDropdownListsForLoanLibraryLoanSearch() {
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/dropdown-lists`,
                requestTypes.GET,
            ),
        );
    }

    static getLoanLibraryLoansReport(loanLibraryLoanSearchCriteria: Record<string, unknown>) {
        const params = {
            ...loanLibraryLoanSearchCriteria,
        };
        const queryParameters = new URLSearchParams(params as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `loan-library/reports/loan/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }

    static returnItem(returnDto: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${LOAN_LIBRARY_LOAN_API_URL}/return`,
                requestTypes.POST,
                JSON.stringify(returnDto),
                apiConstants.successMessage.loanLibrary.LOAN_UPDATED,
            ),
        );
    }
}

export const loanLibraryLoanApi = config.environment.MODE === config.modes.SERVER ? serverLoanLibraryLoanApi : serverLoanLibraryLoanApi;

